<template>
  <div class="pageDisplay">
    <div class="container display">
      <div class="title" v-scroll-reveal>页面展示</div>
      <div class="title_border" v-scroll-reveal></div>
      <div class="display_box">
        <div class="display_box_left">
          <div class="display_box_title">
            <span class="display_box_title_p">Classic pages</span>
            <p>经典页面</p>
          </div>
          <div class="nav">
            <div class="nav_item" v-for="(item, index) in navData" :key="index" @mouseover="navmover(index)" @mouseleave="resetTimer">
              <span :class="{nav_item_a: navIndex === index}">{{ item.title }}</span>
              <img v-show="navIndex === index" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/display_border.png" alt="">
            </div>
          </div>
          <div class="title" style="text-align: left;margin-top: 111px;">货满满{{ typeTitle }}</div>
          <p class="display_box_left_content" style="margin-top: 30px;">整车零担秒接单 货运流程变简单</p>
          <p class="display_box_left_content">一手货源就来货满满 专业的智能货运平台</p>
          <ul>
            <!-- imgsrc属性为APP预览图 -->
            <li v-for="(item, index) in qrCodeData" @mouseover="qecodeover(index)" :key="index">
              <img :src="qrcodeIndex === index ? item.icon2 : item.icon" alt="IOS版">
              <span :style="{color: qrcodeIndex === index ? '#4e9bff' : '#333333'}">{{ item.title }}</span>
              <div class="scanCode" :style="qrcodeIndex === index ? 'display: block' : 'display: none'">
                <img :src="item.url" alt="IOS版">
                <p>{{ item.title }}</p>
                <div class="triangle"></div>
              </div>
            </li>
          </ul>
        </div>
        <div class="display_box_right">
          <div class="display_box_right_img">
            <img :src="navData[navIndex].imgSrc" alt="">
          </div>
          <img class="display_box_right_pos" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/display_line.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageDisplay",
  props: ['qrCodeData', 'navData', 'typeTitle'],
  data() {
    return{
      timer2: null, // nav
      qrcodeIndex: 0,

      navIndex: 0,

    }
  },
  created() {
    this.resetTimer()
  },
  methods: {
    /**
     * @description: 鼠标划入到二维码中
     * @author: 书童
     */
    qecodeover(num) {
        this.qrcodeIndex = num
    },
    /**
     * @description: 鼠标划入到nav中
     * @author: 书童
     */
    navmover(num) {
      clearInterval(this.timer2)
      this.navIndex = num
    },
    /**
     * @description: 开始自动轮播nav item
     * @author: 书童
     */
    resetTimer() {
      this.timer2 = setInterval(() => {
        if (this.navIndex <= this.navData.length - 2) {
          this.navIndex++
        } else {
          this.navIndex = 0
        }
      }, 1500)
    },
  }
}
</script>

<style scoped lang="scss">
.title{
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #333333;
  line-height: 42px;
  margin-top: 70px;
}
.title_border{
  width: 40px;
  height: 2px;
  background: #f39801;
  margin: 6px auto 0;
}
.pageDisplay{
  overflow: hidden;
  height: 1019px;
  width: 100%;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/display_bg.png') no-repeat;
  background-size: 100% 519px;
  background-position: 0 500px;
  padding-top: 1px;
  box-sizing: border-box;
  .display{
    height: 1019px;
    padding: 0 45px;
    box-sizing: border-box;
    .display_box{
      display: flex;
      justify-content: space-between;
      //width: 100%;
      height: 899px;
      padding-top: 54px;
      box-sizing: border-box;
      .display_box_left{
        width: 725px;
        .display_box_title{
          position: relative;
          height: 98px;
          margin-top: 97px;
          p{
            position: relative;
            z-index: 2;
            font-size: 30px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: LEFT;
            color: #333333;
            line-height: 42px;
          }
          .display_box_title_p{
            position: absolute;
            left: 0;
            top: 0;
            font-size: 70px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: LEFT;
            color: #e0e0e0;
            line-height: 98px;
          }
        }
        .nav{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: nowrap;
          height: 41px;
          margin-top: 20px;
          .nav_item{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            margin-right: 50px;
            height: 100%;
            min-width: 50px;
            // width: auto!important;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: center;
            color: #333333;
            line-height: 22px;
            img{
              display: block;
              width: 48px;
              height: 12px;
            }
          }
          .nav_item_a{
            color: #4E9BFF;
          }
        }
        .display_box_left_content{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #666666;
          line-height: 22px;
          margin-top: 10px;
        }
        ul{
          margin-top: 30px;
          li{
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 152px;
            height: 56px;
            background: #ffffff;
            border-radius: 10px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: #333333;
            margin-top: 13px;
            cursor: pointer;
            &>img{
              display: block;
              width: 24px;
              height: 24px;
              margin-right: 12px;
            }
            .scanCode{
              display: none;
              position: absolute;
              top: 0;
              right: -186px;
              width: 176px;
              height: 202px;
              padding: 10px;
              box-sizing: border-box;
              border-radius: 10px;
              background-color: #fff;
              box-shadow: 0px 2px 10px 0px rgba(78,155,255,0.10);
              &>img{
                display: block;
                width: 156px;
                height: 156px;
              }
              .triangle{
                position: absolute;
                top: 18px;
                left: -15px;
                width: 0;
                height: 0;
                border: 8px solid transparent;
                border-right: 10px solid #ffffff;
              }
              p {
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Medium;
                font-weight: 500;
                text-align: center;
                color: #333333;
                line-height: 20px;
                margin-top: 10px;
              }
            }

          }
        }
      }
      .display_box_right{
        position: relative;
        flex: 1;
        height: 100%;
        .display_box_right_img{
          display: block;
          width: 380px;
          height: 765px;
          &>img{
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .display_box_right_pos{
          position: absolute;
          left: -349px;
          top: 408px;
          width:283px;
          height: 222px;
        }
      }

    }
  }
}
</style>